var _a;
import { isAndroid, isWeb } from "@tamagui/constants";
function expandStyle(key, value) {
  if (process.env.TAMAGUI_TARGET === "web") {
    if (key === "flex") {
      return [
        ["flexGrow", value],
        ["flexShrink", 1],
        ["flexBasis", "auto"]
      ];
    }
    switch (key) {
      case "textAlignVertical": {
        return [["verticalAlign", value === "center" ? "middle" : value]];
      }
      case "writingDirection": {
        return [["direction", value]];
      }
    }
  }
  if (process.env.TAMAGUI_TARGET === "native" && isAndroid && key === "elevationAndroid") {
    return [["elevation", value]];
  }
  const longKey = EXPANSIONS[key];
  if (longKey) {
    return longKey.map((key2) => {
      return [key2, value];
    });
  }
}
const all = ["Top", "Right", "Bottom", "Left"];
const horiz = ["Right", "Left"];
const vert = ["Top", "Bottom"];
const xy = ["X", "Y"];
const EXPANSIONS = {
  borderColor: ["TopColor", "RightColor", "BottomColor", "LeftColor"],
  borderRadius: [
    "TopLeftRadius",
    "TopRightRadius",
    "BottomRightRadius",
    "BottomLeftRadius"
  ],
  borderWidth: ["TopWidth", "RightWidth", "BottomWidth", "LeftWidth"],
  margin: all,
  marginHorizontal: horiz,
  marginVertical: vert,
  overscrollBehavior: xy,
  padding: all,
  paddingHorizontal: horiz,
  paddingVertical: vert,
  ...isWeb && {
    // react-native only supports borderStyle
    borderStyle: ["TopStyle", "RightStyle", "BottomStyle", "LeftStyle"],
    // react-native doesn't support X / Y
    overflow: xy
  }
};
for (const parent in EXPANSIONS) {
  const prefix = parent.slice(0, ((_a = /[A-Z]/.exec(parent)) == null ? void 0 : _a.index) ?? parent.length);
  EXPANSIONS[parent] = EXPANSIONS[parent].map((k) => `${prefix}${k}`);
}
export {
  expandStyle
};
//# sourceMappingURL=expandStyle.js.map
